export default {
    modules: {
        deviceMonitor: '设备监测',
        monitoringPoint: '资产',
        Map: '地图',
        incubator: '保温箱',
        fridge: '冰箱',
        car: '冷藏车',
        refrigeratory: '后补式冷库',
        detailData: '详细数据',
        ex: '异常',
        exReason: '异常原因',
        sensor: '传感器',
        gateway: '网关',
        display: '显示屏',
        relay: '中继',
        base: '智能底座',
        scene: '组织架构',
        organizationStructure: '组织架构',
        proberange: '监测区间',
        alarmRecord: '报警记录',
        collectRecord: '采集记录',
        workOrder: '工单',
        contact: '联系人',
        download: '下载',
        noticelog: '通知日志',
        sysLog: '系统日志',
        alarmLog: '报警开关日志',
        user: '用户',
        role: '角色',
        customer: '企业',
        probeunit: '计量单位',
        forwarding: '转发设置',
        param: '参数',
        carrierType: '资产类型',
        monitorTask: '检测任务',
        deviceType: '探测设备类型',
        deviceTransfer: '设备借调',
        resource: '访问资源',
        warehouse: '仓库',
        overview: '总览',
        store: '店铺',
        exportTask: '导出任务',
        statistic: '统计',
        invalidRule: '无效规则',
        gas: '气体',
        magnetism: '门磁',
         verificationTask: '验证任务',
        onlineHelp: '在线帮助设置',


    }
};
